import {
  SELECTED_TOOL_CHANGED,
  SELECTED_TOOL_CHANGED_FROM_OUTSIDE,
} from "../actions/actionTypes";
import Tools from "../components/Sketch/tools";
const defaultState = {
  selectedTool: Tools.Pan,
  selectedToolChangedFromOutside: false,
  shouldCloseTheMenu: true,
  previousTool:Tools.Select,
};
export default (state = defaultState, action) => {
  switch (action.type) {
    case SELECTED_TOOL_CHANGED:
      if (action.payload == "shapes" && state.selectedTool == "shapes") {
        return {
          ...state,
          previousTool: state.selectedTool,
          selectedTool: Tools.Select,
          selectedToolChangedFromOutside: false,
          shouldCloseTheMenu:true,
        };
      }
      if (
        action.payload == "eraseall" ||
        // action.payload == "eraseselected" ||
        action.payload == "eraseser"
      ) {
        return {
          ...state,
          previousTool: state.selectedTool,
          selectedTool: Tools.Select,
          selectedToolChangedFromOutside: false,
          shouldCloseTheMenu:true,
        };
      }
      return {
        ...state,
        previousTool: state.selectedTool,
        selectedTool: action.payload,
        selectedToolChangedFromOutside: false,
        shouldCloseTheMenu:true,
      };
    case SELECTED_TOOL_CHANGED_FROM_OUTSIDE:
      if (
        action.payload[0] == "eraseall"
        // || action.payload == "eraseselected"
      ) {
        return {
          ...state,
          previousTool: state.selectedTool,
          selectedTool: Tools.Select,
          selectedToolChangedFromOutside: true,
          shouldCloseTheMenu: action.payload[1],
        };
      }
      return {
        ...state,
        previousTool: state.selectedTool,
        selectedTool: action.payload[0],
        selectedToolChangedFromOutside: true,
        shouldCloseTheMenu: action.payload[1],
      };

    default:
      return state;
  }
};
